module.exports = __webpack_public_path__ + "img/電気回路_1_6_5.ee99e6e3.png";